<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
    <mat-panel-title>
        Employer Information
    </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="p-4">
    <!-- Employer Info Form -->
    <form [formGroup]="userInfoForm">        
        <div class="row">
            <h5 class="col-md-8 labelText">Employer Information</h5>      
            <div class="col-md-4 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                <button class="clear-data-button" (click)="clearData()">
                    <i class="fa fa-repeat"></i> Clear Data
                 </button>
            </div>
        </div>
        <div class="row">
            <!-- Company Name -->
            <div class="form-group col-md-4">
                <mat-form-field *ngIf="userType === 'Petitioner'"> 
                    <label class="label-cls required">Company Name</label>
                    <mat-select name="companyName"
                                formControlName="companyName"
                                (selectionChange)="onChangeCompany($event.value)">
                      <mat-option *ngFor="let item of listCompany" [value]="item.id">
                        {{item.companyName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="userType === 'Attorney'"> 
                    <label class="label-cls required">Company Name</label>
                    <mat-select name="companyName"
                                formControlName="companyName"
                                (selectionChange)="onChangeCompany($event.value)">
                      <mat-option *ngFor="let item of listCompany" [value]="item.petitionerId">
                        {{item.petitionerName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('companyName').touched && userInfoForm.get('companyName').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div> 
        </div>
        <div class="row">
            <!-- Legal Business Name -->
            <div class="form-group col-md-4">
                <label class="label-cls required">Legal Business Name</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        type="text" 
                        name="legalBusinessName" 
                        formControlName="legalBusinessName"
                        placeholder="Enter" />
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('legalBusinessName').touched && userInfoForm.get('legalBusinessName').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div> 
        </div>
        <div class="row">
            <!-- Trade name -->
            <div class="form-group col-md-4">
                <label class="control-lbl required mt-2 label-cls">Trade name/Doing Business As (DBA), if applicable</label>
                <br>
                <mat-radio-group name="hasTradeNameorDBA" formControlName="hasTradeNameorDBA"
                (change)="onChangeHasTradeNameorDBA($event.value)">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No </mat-radio-button>
                </mat-radio-group>
            </div>
            <!-- Doing Business As (DBA) -->
            <div class="form-group col-md-4" *ngIf="userInfoForm.get('hasTradeNameorDBA')?.value"> 
                <label class="control-lbl required mt-2 label-cls">Trade name/Doing Business As (DBA)</label>
                <input class="im-input"
                        type="text" 
                        name="tradeNameOrDBA" 
                        formControlName="tradeNameOrDBA"
                        placeholder="Enter" />
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('tradeNameOrDBA').touched && userInfoForm.get('tradeNameOrDBA').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
        </div>
        <div class="row">
            <!-- Address 1 -->
            <div class="form-group col-md-6">
                <label class="control-lbl mt-2 required label-cls">Address 1</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        type="text" 
                        name="addressLine1"
                        formControlName="addressLine1"
                        placeholder="Enter" />
                <mat-hint>Ex. : Street Name & Number</mat-hint>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('addressLine1').touched && userInfoForm.get('addressLine1').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
        </div>
        <div class="row">
            <!-- Address 2 -->
            <div class="form-group col-md-6">
                <label class="control-lbl mt-2 label-cls">Address 2</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        type="text" 
                        name="addressLine2"
                        formControlName="addressLine2"
                        placeholder="Enter" />
                <mat-hint>Ex. : Apartment., Suite, Building</mat-hint>
            </div>
        </div> 
        <div class="row  mt-2"> 
            <!-- Country -->
            <div class="form-group col-md-4">
                <mat-form-field> 
                    <label class="label-cls required">Country</label>
                    <mat-select [ngClass]="userInfoForm.get('companyName').value ? 'disable' : ''" 
                                [disabled]="userInfoForm.get('companyName').value"
                                name="country"
                                formControlName="country"
                                (selectionChange)="onChangeCountry($event.value)">
                      <mat-option *ngFor="let item of listCountry" [value]="item.countryCode">
                        {{item.countryName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>

                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('country').touched && userInfoForm.get('country').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- State -->
            <div class="form-group col-md-4">
                <mat-form-field> 
                    <label class="label-cls required">State</label>
                    <mat-select [ngClass]="userInfoForm.get('companyName').value ? 'disable' : ''" 
                                [disabled]="userInfoForm.get('companyName').value"
                                name="state"
                                formControlName="state">
                      <mat-option *ngFor="let item of listStates" [value]="item.stateProvinceCode">
                        {{item.stateProvinceName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('state').touched && userInfoForm.get('state').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- City -->
            <div class="form-group col-md-4">
                <label class="col-md-12 label-cls required">City</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="city"
                        formControlName="city"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('city').touched && userInfoForm.get('city').invalid) || (userInfoForm.get('city').touched && userInfoForm.get('city').errors?.required)">
                    {{ getGlobalErrorMessages("INVALID_CITY") }}
                </span>
            </div> 
        </div>
        <div class="row  mt-2">
            <!-- ZIP / Postal Code -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">ZIP / Postal Code</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="postalCode"
                        formControlName="postalCode"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('postalCode').touched && userInfoForm.get('postalCode').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- Province -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Province</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="stateProvinceName"
                        formControlName="stateProvinceName"
                        type="text"
                        placeholder="Enter"/>
            </div>
            <!-- Extension -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Extension</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="extension"
                        formControlName="extension"
                        type="text"
                        placeholder="Enter" />
                <span class="invalid-message" 
                        *ngIf="(userInfoForm.get('extension').touched  && userInfoForm.get('extension').invalid)">
                {{ getGlobalErrorMessages("INVALID_EXTENSION") }}
                </span>
            </div>
        </div> 
        <div class="row mt-2">
            <!-- Telephone Number -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">Telephone Number</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="telephone"
                        formControlName="telephone"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('telephone').touched && userInfoForm.get('telephone').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- NAICS code -->
            <!-- <div class="form-group col-md-4"> 
                <label class="label-cls">NAICS code</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="naicsCode"
                        formControlName="naicsCode"
                        type="text"
                        placeholder="Enter"/>
            </div> -->
            <div class="form-group col-md-4">
                <!-- <mat-form-field>  -->
                    <label class="label-cls">NAICS code</label>
                    <mat-select name="naicsCode"
                                formControlName="naicsCode"
                                placeholder="Select"
                                (selectionChange)="onChangeNaics($event.value)">
                      <mat-option *ngFor="let item of listNaics" [value]="item?.naicsCode" [matTooltip]="item?.naicsTitle">
                        {{item?.naicsTitle}}
                      </mat-option> 
                    </mat-select>
                <!-- </mat-form-field> -->
            </div> 
            <!-- Federal Employer Identification Number -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">Federal Employer Identification Number from IRS</label>
                <input [ngClass]="userInfoForm.get('companyName').value ? 'im-input disable' : 'im-input'"
                        name="feiNumber"
                        formControlName="feiNumber"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(userInfoForm.get('feiNumber').touched && userInfoForm.get('feiNumber').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
        </div>
    </form>
</div>

<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>


